/* ==========================================================================
   QUICK SNEAKERS — theme.js
   Vanilla ES2017. No dependencies. Talks to the standard Shopify AJAX API
   (/cart.js, /cart/add.js, /cart/change.js, /search/suggest.json,
   /products/{handle}.js) so the exact same file powers the local demo
   (where those endpoints are mocked) and the live Shopify theme.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------ config -- */
  var USER = window.QuickSneakers || {};

  // NOTE: routes/strings are merged key-by-key. A plain Object.assign would let
  // a partial `routes` object from the page wipe out the endpoint defaults.
  var CFG = window.QuickSneakers = Object.assign({
    moneyFormat: '${{amount}}',
    cartType: 'drawer'
  }, USER, {
    routes: Object.assign({
      root: '/',
      cart: '/cart',
      cartAdd: '/cart/add.js',
      cartChange: '/cart/change.js',
      cartUrl: '/cart.js',
      search: '/search',
      suggest: '/search/suggest.json',
      checkout: '/checkout'
    }, USER.routes),
    strings: Object.assign({
      selectSize: 'Please select a size',
      added: 'Added to bag',
      removed: 'Removed',
      favAdded: 'Saved to favorites',
      favRemoved: 'Removed from favorites',
      soldOut: 'Sold out',
      addToBag: 'Add to bag',
      buyNow: 'Buy it now',
      emptyCart: 'Your bag is empty',
      emptyFav: 'No favorites yet',
      viewAll: 'View all results',
      noResults: 'No products found',
      size: 'Size',
      qty: 'Qty',
      subtotal: 'Subtotal',
      remove: 'Remove'
    }, USER.strings)
  });

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, wait);
    };
  }

  /* ------------------------------------------------------------- money -- */
  function formatMoney(cents, format) {
    var fmt = format || CFG.moneyFormat || '${{amount}}';
    var value = (typeof cents === 'string') ? cents.replace('.', '') : cents;
    value = Number(value) || 0;

    function fmtNum(num, precision, thousands, decimal) {
      if (isNaN(num)) num = 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision ? head + decimal + parts[1] : head;
    }

    var out = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var name = placeholder ? placeholder[1] : 'amount';

    switch (name) {
      case 'amount': out = fmtNum(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = fmtNum(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmtNum(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmtNum(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fmtNum(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fmtNum(value, 0, ' ', ''); break;
      case 'amount_with_period_and_space_separator': out = fmtNum(value, 2, ' ', '.'); break;
      default: out = fmtNum(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  CFG.formatMoney = formatMoney;

  /* ------------------------------------------------------------- toast -- */
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20 6L9 17l-5-5"/></svg>';
  function toast(msg, icon) {
    var host = $('#toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'toast-host';
      host.className = 'toast-host';
      document.body.appendChild(host);
    }
    var el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    el.innerHTML = (icon === false ? '' : CHECK) + '<span>' + esc(msg) + '</span>';
    host.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { el.remove(); }, 420);
    }, 2600);
  }
  CFG.toast = toast;

  /* ------------------------------------------------------------ drawer -- */
  var Drawer = (function () {
    var open = [];
    var lastFocus = null;

    function overlay() {
      var o = $('#overlay');
      if (!o) {
        o = document.createElement('div');
        o.id = 'overlay';
        o.className = 'overlay';
        document.body.appendChild(o);
        on(o, 'click', function () { closeAll(); });
      }
      return o;
    }

    function show(id) {
      var el = document.getElementById(id);
      if (!el || open.indexOf(id) > -1) return;
      lastFocus = document.activeElement;
      overlay().classList.add('is-open');
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      document.body.classList.add('is-locked');
      open.push(id);
      var f = el.querySelector('[data-drawer-focus], button, a, input');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 260);
      document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: id } }));
    }

    function hide(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      open = open.filter(function (x) { return x !== id; });
      if (!open.length) {
        overlay().classList.remove('is-open');
        document.body.classList.remove('is-locked');
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
    }

    function closeAll() {
      open.slice().forEach(hide);
      $$('.modal.is-open').forEach(function (m) { Modal.hide(m.id); });
      var sheet = $('#search-sheet');
      if (sheet) sheet.classList.remove('is-open');
    }

    return { show: show, hide: hide, closeAll: closeAll, isOpen: function (id) { return open.indexOf(id) > -1; } };
  })();
  CFG.Drawer = Drawer;

  var Modal = {
    show: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      document.body.classList.add('is-locked');
    },
    hide: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (!$('.drawer.is-open') && !$('.modal.is-open')) document.body.classList.remove('is-locked');
    }
  };
  CFG.Modal = Modal;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      Drawer.show(openBtn.getAttribute('data-drawer-open'));
      return;
    }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      var id = closeBtn.getAttribute('data-drawer-close');
      if (id) Drawer.hide(id); else Drawer.closeAll();
      return;
    }
    var modalClose = e.target.closest('[data-modal-close]');
    if (modalClose) {
      e.preventDefault();
      Modal.hide(modalClose.getAttribute('data-modal-close') || 'quick-view');
      return;
    }
    if (e.target.classList && e.target.classList.contains('modal__scrim')) {
      var m = e.target.closest('.modal');
      if (m) Modal.hide(m.id);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Drawer.closeAll();
    $$('[data-nav-item].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* -------------------------------------------------------- mobile nav -- */
  function initMobileNav() {
    $$('.mnav__toggle').forEach(function (btn) {
      if (btn.dataset.navBound) return;
      btn.dataset.navBound = '1';
      on(btn, 'click', function (e) {
        e.preventDefault();
        var panel = btn.closest('.mnav__item').querySelector('.mnav__sub');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (!panel) return;
        panel.classList.toggle('is-open', !isOpen);
        /* Measure instead of relying on a fixed max-height, which clipped
           any submenu taller than the cap. */
        panel.style.maxHeight = isOpen ? '' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------------------------------------------------- desktop nav -- */
  /* Hover and :focus-within open the panels in CSS. Pointer-coarse devices
     wide enough for the desktop bar have no hover, so the first tap on a
     parent opens its panel and the second follows the link. */
  function initNavDropdowns() {
    if (window.matchMedia('(hover: hover)').matches) return;
    $$('[data-nav-trigger]').forEach(function (trigger) {
      if (trigger.dataset.navBound) return;
      trigger.dataset.navBound = '1';
      on(trigger, 'click', function (e) {
        var item = trigger.closest('[data-nav-item]');
        if (!item || item.classList.contains('is-open')) return;
        e.preventDefault();
        $$('[data-nav-item].is-open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-nav-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
  }

  on(document, 'click', function (e) {
    if (e.target.closest('[data-nav-item]')) return;
    $$('[data-nav-item].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ------------------------------------------------- predictive search -- */
  function initSearch(scope) {
    $$('[data-search]', scope || document).forEach(function (form) {
      var input = form.querySelector('input[type="search"], input[name="q"]');
      var box = form.querySelector('[data-suggest]');
      if (!input || !box) return;

      var cache = {};
      var controller = null;

      function close() { box.classList.remove('is-open'); box.innerHTML = ''; }

      function render(q, products) {
        if (!products.length) {
          box.innerHTML = '<div class="suggest__empty">' + esc(CFG.strings.noResults) + ' — “' + esc(q) + '”</div>';
          box.classList.add('is-open');
          return;
        }
        var html = '<div class="suggest__head">' + products.length + ' result' + (products.length > 1 ? 's' : '') + '</div>';
        products.forEach(function (p) {
          var img = p.featured_image || p.image || '';
          var price = (p.price != null) ? formatMoney(p.price) : (p.price_min != null ? formatMoney(p.price_min) : '');
          html += '<a class="suggest__item" href="' + esc(p.url) + '">' +
            (img ? '<img class="suggest__img" src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">'
                 : '<span class="suggest__img"></span>') +
            '<span><span class="suggest__title">' + esc(p.title) + '</span>' +
            (p.vendor ? '<span class="suggest__meta">' + esc(p.vendor) + '</span>' : '') +
            '</span><span class="suggest__price">' + price + '</span></a>';
        });
        html += '<a class="suggest__all" href="' + esc(CFG.routes.search) + '?q=' + encodeURIComponent(q) + '">' + esc(CFG.strings.viewAll) + '</a>';
        box.innerHTML = html;
        box.classList.add('is-open');
      }

      var run = debounce(function () {
        // case-insensitive on both sides: normalise before sending, and the
        // mock/Shopify endpoints both match case-insensitively.
        var q = input.value.trim();
        if (q.length < 1) { close(); return; }
        var key = q.toLowerCase();
        if (cache[key]) { render(q, cache[key]); return; }

        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;

        var url = CFG.routes.suggest + '?q=' + encodeURIComponent(key) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';

        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            cache[key] = items;
            render(q, items);
          })
          .catch(function (err) { if (err && err.name !== 'AbortError') close(); });
      }, 180);

      on(input, 'input', run);
      on(input, 'focus', function () { if (input.value.trim()) run(); });
      on(document, 'click', function (e) { if (!form.contains(e.target)) close(); });
      on(input, 'keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); }
      });
    });

    // mobile search sheet
    var sheet = $('#search-sheet');
    $$('[data-search-toggle]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (!sheet) return;
        var willOpen = !sheet.classList.contains('is-open');
        sheet.classList.toggle('is-open', willOpen);
        if (willOpen) {
          var i = sheet.querySelector('input');
          if (i) setTimeout(function () { i.focus(); }, 220);
        }
      });
    });
    $$('[data-search-close]').forEach(function (b) {
      on(b, 'click', function () { if (sheet) sheet.classList.remove('is-open'); });
    });
  }

  /* ------------------------------------------------------- hero slider -- */
  function initHero(root) {
    $$('[data-hero]', root || document).forEach(function (hero) {
      var slides = $$('.hero__slide', hero);
      if (slides.length < 1) return;
      var dots = $$('.hero__dot', hero);
      var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      var speed = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      function go(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) {
          d.classList.remove('is-active');
          d.setAttribute('aria-selected', String(i === idx));
        });
        if (dots[idx]) {
          // restart the progress animation
          var fill = dots[idx].querySelector('span');
          if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
          dots[idx].classList.add('is-active');
        }
        restart();
      }
      function next() { go(idx + 1); }
      function prev() { go(idx - 1); }
      function restart() {
        if (timer) clearInterval(timer);
        if (speed > 0 && slides.length > 1) timer = setInterval(next, speed);
      }

      $$('[data-hero-next]', hero).forEach(function (b) { on(b, 'click', next); });
      $$('[data-hero-prev]', hero).forEach(function (b) { on(b, 'click', prev); });
      dots.forEach(function (d, i) { on(d, 'click', function () { go(i); }); });

      on(hero, 'mouseenter', function () { hero.classList.add('hero--paused'); if (timer) clearInterval(timer); });
      on(hero, 'mouseleave', function () { hero.classList.remove('hero--paused'); restart(); });
      on(document, 'visibilitychange', function () {
        if (document.hidden) { if (timer) clearInterval(timer); } else restart();
      });

      // swipe
      var x0 = null;
      on(hero, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(hero, 'touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
        x0 = null;
      }, { passive: true });

      if (slides.length) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
      restart();
    });
  }

  /* ------------------------------------------------------------ reveal -- */
  function initReveal(scope) {
    var els = $$('.reveal:not(.is-in)', scope || document);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var d = en.target.getAttribute('data-delay');
          if (d) en.target.style.transitionDelay = d + 'ms';
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------- carousel -- */
  function initRails(scope) {
    $$('[data-rail]', scope || document).forEach(function (wrap) {
      var rail = wrap.querySelector('.rail');
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (!rail) return;
      function step() {
        var first = rail.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      on(prev, 'click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(rail, 'scroll', debounce(sync, 90), { passive: true });
      window.addEventListener('resize', debounce(sync, 200));
      sync();
    });
  }

  /* --------------------------------------------------- product marquee -- */
  /* CSS pauses the row on hover, which covers a mouse. Touch has no hover, so
     a tap inside the row latches it paused until the next tap outside — the
     size buttons and Buy now in each card are unusable otherwise.

     The second copy of the row is aria-hidden, and an aria-hidden subtree must
     not hold anything focusable, so its controls are taken out of the tab
     order here rather than in Liquid. */
  function initProductMarquee(scope) {
    $$('[data-product-marquee]', scope || document).forEach(function (mq) {
      /* Idempotent, so it runs on every call — the listeners are guarded, but
         the tab-order sweep is not, or a row whose cards arrive after the
         first call would keep its hidden copy focusable. */
      $$('[aria-hidden="true"] a, [aria-hidden="true"] button, [aria-hidden="true"] input, [aria-hidden="true"] [tabindex]', mq)
        .forEach(function (el) { el.setAttribute('tabindex', '-1'); });

      if (mq.__wired) return;
      mq.__wired = true;

      on(mq, 'pointerdown', function () { mq.classList.add('is-paused'); });
      on(document, 'pointerdown', function (e) {
        if (!mq.contains(e.target)) mq.classList.remove('is-paused');
      });
    });
  }

  /* ------------------------------------------------------------- sizes -- */
  /* Wires any [data-picker] block: size buttons gate the CTA buttons.     */
  function initPicker(root) {
    $$('[data-picker]', root || document).forEach(function (picker) {
      if (picker.__wired) return;
      picker.__wired = true;

      var scope = picker.closest('[data-product-form]') || picker.parentElement;
      var err = scope.querySelector('[data-picker-error]');
      var valueOut = picker.querySelector('[data-picker-value]');
      // the hidden field is [data-variant-id]; the size buttons carry
      // [data-size-id] so they can never shadow it in a querySelector
      var variantInput = scope.querySelector('input[data-variant-id]');
      var ctas = $$('[data-requires-size]', scope);
      var priceOut = scope.querySelector('[data-variant-price]');

      function lock() {
        ctas.forEach(function (b) {
          b.setAttribute('aria-disabled', 'true');
          b.disabled = true;
        });
      }
      function unlock() {
        ctas.forEach(function (b) {
          b.removeAttribute('aria-disabled');
          b.disabled = false;
        });
      }
      lock();

      $$('.size', picker).forEach(function (btn) {
        on(btn, 'click', function () {
          if (btn.classList.contains('is-soldout') || btn.disabled) return;
          $$('.size', picker).forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          if (variantInput) variantInput.value = btn.getAttribute('data-size-id') || '';
          if (valueOut) valueOut.textContent = btn.getAttribute('data-size') || btn.textContent.trim();
          if (priceOut && btn.getAttribute('data-price')) {
            priceOut.innerHTML = formatMoney(btn.getAttribute('data-price'));
          }
          if (err) err.classList.remove('is-on');
          unlock();
        });
      });

      // clicking a locked CTA still prompts the shopper
      ctas.forEach(function (btn) {
        var guard = btn.parentElement;
        if (!guard) return;
        on(guard, 'click', function (e) {
          if (btn.disabled && guard.contains(e.target)) {
            if (err) {
              err.classList.remove('is-on');
              void err.offsetWidth;
              err.classList.add('is-on');
            }
            toast(CFG.strings.selectSize, false);
            picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }, true);
      });
    });
  }

  /* ---------------------------------------------------------- quantity -- */
  function initQty(scope) {
    $$('[data-qty]', scope || document).forEach(function (box) {
      if (box.__wired) return;
      box.__wired = true;
      var input = box.querySelector('input');
      var minus = box.querySelector('[data-qty-minus]');
      var plus = box.querySelector('[data-qty-plus]');
      function clamp() {
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < min) v = min;
        input.value = v;
        if (minus) minus.disabled = v <= min;
      }
      on(minus, 'click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; clamp(); input.dispatchEvent(new Event('change', { bubbles: true })); });
      on(plus, 'click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; clamp(); input.dispatchEvent(new Event('change', { bubbles: true })); });
      on(input, 'change', clamp);
      clamp();
    });
  }

  /* -------------------------------------------------------------- cart -- */
  var Cart = (function () {
    var state = null;

    function get() {
      return fetch(CFG.routes.cartUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { state = c; paint(c); return c; });
    }

    function add(items) {
      return fetch(CFG.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [].concat(items) })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Cart error');
          return d;
        });
      }).then(function (d) { return get().then(function () { return d; }); });
    }

    function change(line, quantity) {
      return fetch(CFG.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function (c) { state = c; paint(c); return c; });
    }

    function count() { return state ? state.item_count : 0; }

    function optionLabel(item) {
      if (!item.options_with_values || !item.options_with_values.length) {
        return (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      }
      return item.options_with_values
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; })
        .join(' · ');
    }

    function lineHTML(item, i) {
      var opts = optionLabel(item);
      var img = item.image || item.featured_image || (item.featured_image && item.featured_image.url) || '';
      if (img && img.indexOf('?') === -1 && img.indexOf('data:') !== 0) img = img + '?width=200';
      return '' +
        '<div class="cart-line" data-line="' + (i + 1) + '">' +
          '<a class="cart-line__media" href="' + esc(item.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="92" height="92">' : '') +
          '</a>' +
          '<div>' +
            '<div class="cart-line__top">' +
              '<div>' +
                (item.vendor ? '<div class="cart-line__vendor">' + esc(item.vendor) + '</div>' : '') +
                '<a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
                (opts ? '<div class="cart-line__opt">' + esc(opts) + '</div>' : '') +
              '</div>' +
              '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
            '<div class="cart-line__bottom">' +
              '<div class="qty qty--sm" data-qty>' +
                '<button class="qty__btn" type="button" data-cart-minus="' + (i + 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                '<input class="qty__input" type="number" min="1" value="' + item.quantity + '" data-cart-qty="' + (i + 1) + '" aria-label="Quantity">' +
                '<button class="qty__btn" type="button" data-cart-plus="' + (i + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="cart-line__remove" type="button" data-cart-remove="' + (i + 1) + '">' + BIN + '<span>' + esc(CFG.strings.remove) + '</span></button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function paint(cart) {
      // counters
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-on', cart.item_count > 0);
      });
      $$('[data-cart-total]').forEach(function (el) { el.innerHTML = formatMoney(cart.total_price); });

      // drawer body
      var body = $('[data-cart-body]');
      if (body) {
        if (!cart.item_count) {
          body.innerHTML = '<div class="drawer-empty">' + BAG_BIG +
            '<p>' + esc(CFG.strings.emptyCart) + '</p>' +
            '<a class="btn btn--full" href="' + esc(CFG.routes.root) + '">Continue shopping</a></div>';
        } else {
          body.innerHTML = cart.items.map(lineHTML).join('');
        }
      }
      var foot = $('[data-cart-foot]');
      if (foot) foot.classList.toggle('hidden', !cart.item_count);

      // full cart page
      var page = $('[data-cart-page]');
      if (page) paintPage(cart);

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }

    function paintPage(cart) {
      var rows = $('[data-cart-rows]');
      var empty = $('[data-cart-empty]');
      var layout = $('[data-cart-layout]');
      if (!rows) return;
      if (!cart.item_count) {
        if (layout) layout.classList.add('hidden');
        if (empty) empty.classList.remove('hidden');
        return;
      }
      if (layout) layout.classList.remove('hidden');
      if (empty) empty.classList.add('hidden');

      rows.innerHTML = cart.items.map(function (item, i) {
        var opts = optionLabel(item);
        var img = item.image || item.featured_image || '';
        if (img && img.indexOf('?') === -1 && img.indexOf('data:') !== 0) img = img + '?width=300';
        return '' +
          '<div class="cart-row" data-line="' + (i + 1) + '">' +
            '<a class="cart-row__media" href="' + esc(item.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="110" height="110">' : '') +
            '</a>' +
            '<div>' +
              (item.vendor ? '<div class="cart-line__vendor">' + esc(item.vendor) + '</div>' : '') +
              '<a class="cart-row__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              (opts ? '<div class="cart-line__opt">' + esc(opts) + '</div>' : '') +
              '<div class="cart-line__price" style="margin-top:8px">' + formatMoney(item.final_price) + '</div>' +
              '<div class="cart-row__actions">' +
                '<div class="qty" data-qty>' +
                  '<button class="qty__btn" type="button" data-cart-minus="' + (i + 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<input class="qty__input" type="number" min="1" value="' + item.quantity + '" data-cart-qty="' + (i + 1) + '" aria-label="Quantity">' +
                  '<button class="qty__btn" type="button" data-cart-plus="' + (i + 1) + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button class="cart-line__remove" type="button" data-cart-remove="' + (i + 1) + '">' + BIN + '<span>' + esc(CFG.strings.remove) + '</span></button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-row__total">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
      initQty(rows);
    }

    return { get: get, add: add, change: change, count: count, paint: paint, state: function () { return state; } };
  })();
  CFG.Cart = Cart;

  var BIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/><path d="M10 11v5M14 11v5"/></svg>';
  var BAG_BIG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 7V5a3 3 0 016 0v2"/></svg>';

  // cart line interactions (delegated — works in drawer and on the page)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-minus]');
    var plus = e.target.closest('[data-cart-plus]');
    var rm = e.target.closest('[data-cart-remove]');
    if (!minus && !plus && !rm) return;
    e.preventDefault();

    var el = minus || plus || rm;
    var line = parseInt(el.getAttribute('data-cart-minus') || el.getAttribute('data-cart-plus') || el.getAttribute('data-cart-remove'), 10);
    var row = el.closest('[data-line]');
    var input = row ? row.querySelector('[data-cart-qty]') : null;
    var qty = input ? (parseInt(input.value, 10) || 1) : 1;
    var target = rm ? 0 : (plus ? qty + 1 : qty - 1);
    if (row) row.classList.add('is-busy');
    Cart.change(line, Math.max(0, target)).then(function () {
      if (rm) toast(CFG.strings.removed);
    }).catch(function () { if (row) row.classList.remove('is-busy'); });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-cart-qty'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    var row = input.closest('[data-line]');
    if (row) row.classList.add('is-busy');
    Cart.change(line, qty);
  });

  /* --------------------------------------------------------- favorites -- */
  var Favorites = (function () {
    var KEY = 'sole-atelier:favorites';
    var list = [];

    function load() {
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      return list;
    }
    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      syncUI();
    }
    function has(handle) { return list.indexOf(handle) > -1; }
    function toggle(handle) {
      if (has(handle)) { list = list.filter(function (h) { return h !== handle; }); save(); return false; }
      list.push(handle); save(); return true;
    }
    function syncUI() {
      $$('[data-fav-count]').forEach(function (el) {
        el.textContent = list.length;
        el.classList.toggle('is-on', list.length > 0);
      });
      $$('[data-fav-toggle]').forEach(function (btn) {
        var h = btn.getAttribute('data-fav-toggle');
        var active = has(h);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
        btn.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
      });
    }

    function render() {
      var body = $('[data-fav-body]');
      if (!body) return;
      if (!list.length) {
        body.innerHTML = '<div class="drawer-empty">' + HEART_BIG +
          '<p>' + esc(CFG.strings.emptyFav) + '</p>' +
          '<a class="btn btn--full" href="' + esc(CFG.routes.root) + '">Explore the drop</a></div>';
        return;
      }
      body.innerHTML = '<div class="drawer-empty" style="padding:30px 0"><p>Loading…</p></div>';
      Promise.all(list.map(function (handle) {
        return fetch(CFG.routes.root.replace(/\/$/, '') + '/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var items = products.filter(Boolean);
        if (!items.length) {
          body.innerHTML = '<div class="drawer-empty">' + HEART_BIG + '<p>' + esc(CFG.strings.emptyFav) + '</p></div>';
          return;
        }
        body.innerHTML = items.map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          if (img && img.indexOf('?') === -1 && img.indexOf('data:') !== 0) img += '?width=200';
          return '' +
            '<div class="fav-line" data-fav-line="' + esc(p.handle) + '">' +
              '<a class="fav-line__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="92" height="92">' : '') + '</a>' +
              '<div>' +
                (p.vendor ? '<div class="cart-line__vendor">' + esc(p.vendor) + '</div>' : '') +
                '<a class="cart-line__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
                '<div class="cart-line__price" style="margin-top:6px">' + formatMoney(p.price) + '</div>' +
                '<div class="fav-line__actions">' +
                  '<button class="btn btn--sm btn--ghost" type="button" data-quick-view="' + esc(p.handle) + '">Select size</button>' +
                  '<button class="cart-line__remove" type="button" data-fav-remove="' + esc(p.handle) + '">' + BIN + '<span>' + esc(CFG.strings.remove) + '</span></button>' +
                '</div>' +
              '</div>' +
            '</div>';
        }).join('');
      });
    }

    load();
    return { load: load, has: has, toggle: toggle, syncUI: syncUI, render: render, list: function () { return list.slice(); } };
  })();
  CFG.Favorites = Favorites;

  var HEART_BIG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M12 20s-7-4.4-7-9.3A4.2 4.2 0 0112 8a4.2 4.2 0 017 2.7c0 4.9-7 9.3-7 9.3z"/></svg>';

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fav-toggle]');
    if (t) {
      e.preventDefault();
      var added = Favorites.toggle(t.getAttribute('data-fav-toggle'));
      toast(added ? CFG.strings.favAdded : CFG.strings.favRemoved);
      if (Drawer.isOpen('favorites-drawer')) Favorites.render();
      return;
    }
    var rm = e.target.closest('[data-fav-remove]');
    if (rm) {
      e.preventDefault();
      Favorites.toggle(rm.getAttribute('data-fav-remove'));
      Favorites.render();
      toast(CFG.strings.favRemoved);
    }
  });

  document.addEventListener('drawer:open', function (e) {
    if (e.detail.id === 'favorites-drawer') Favorites.render();
  });

  /* -------------------------------------------------------- quick view -- */
  var QuickView = (function () {
    var cache = {};

    function fetchProduct(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch(CFG.routes.root.replace(/\/$/, '') + '/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { cache[handle] = p; return p; });
    }

    function sizeOptionIndex(p) {
      var names = (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name || '').toLowerCase(); });
      var i = names.findIndex(function (n) { return n.indexOf('size') > -1 || n.indexOf('مقاس') > -1 || n.indexOf('uk') > -1 || n.indexOf('us') > -1; });
      return i > -1 ? i : 0;
    }

    function render(p) {
      var panel = $('#quick-view-panel');
      if (!panel) return;
      var oi = sizeOptionIndex(p);
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('?') === -1 && img.indexOf('data:') !== 0) img += '?width=900';

      var onSale = p.compare_at_price_max > p.price;
      var priceHTML = '<span class="' + (onSale ? 'price--sale' : '') + '">' + formatMoney(p.price) + '</span>' +
        (onSale ? '<span class="price__was">' + formatMoney(p.compare_at_price_max) + '</span>' : '');

      var sizes = p.variants.map(function (v) {
        var label = v['option' + (oi + 1)] || v.title;
        return '<button class="size' + (v.available ? '' : ' is-soldout') + '" type="button" ' +
          'data-size-id="' + v.id + '" data-size="' + esc(label) + '" data-price="' + v.price + '" ' +
          (v.available ? '' : 'disabled ') + 'aria-pressed="false">' + esc(label) + '</button>';
      }).join('');

      var desc = (p.description || '').replace(/<[^>]*>/g, ' ').trim().slice(0, 260);

      panel.innerHTML = '' +
        '<button class="modal__close" type="button" data-modal-close="quick-view" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="qv" data-product-form>' +
          '<div class="qv__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
          '<div class="qv__body">' +
            (p.vendor ? '<div class="qv__vendor">' + esc(p.vendor) + '</div>' : '') +
            '<h2 class="qv__title">' + esc(p.title) + '</h2>' +
            '<div class="qv__price" data-variant-price>' + priceHTML + '</div>' +
            (desc ? '<p class="qv__desc">' + esc(desc) + '…</p>' : '') +
            '<div class="picker" data-picker>' +
              '<div class="picker__head">' +
                '<span class="picker__label">' + esc(CFG.strings.size) + '</span>' +
                '<span class="picker__value" data-picker-value>Select</span>' +
              '</div>' +
              '<div class="sizes">' + sizes + '</div>' +
            '</div>' +
            '<div class="picker__error" data-picker-error>' + esc(CFG.strings.selectSize) + '</div>' +
            '<input type="hidden" data-variant-id value="">' +
            '<div class="qv__actions">' +
              '<span><button class="btn btn--ghost btn--full" type="button" data-add-to-cart data-requires-size disabled aria-disabled="true">' + esc(CFG.strings.addToBag) + '</button></span>' +
              '<span><button class="btn btn--full" type="button" data-buy-now data-requires-size disabled aria-disabled="true">' + esc(CFG.strings.buyNow) + '</button></span>' +
            '</div>' +
            '<a class="link-underline qv__link" href="' + esc(p.url) + '">View full details</a>' +
          '</div>' +
        '</div>';

      initPicker(panel);
    }

    function open(handle) {
      Modal.show('quick-view');
      var panel = $('#quick-view-panel');
      if (panel) panel.innerHTML = '<div class="drawer-empty" style="padding:80px 20px"><p>Loading…</p></div>';
      fetchProduct(handle).then(render).catch(function () {
        if (panel) panel.innerHTML = '<div class="drawer-empty" style="padding:80px 20px"><p>Product unavailable.</p></div>';
      });
    }

    return { open: open };
  })();
  CFG.QuickView = QuickView;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b) return;
    e.preventDefault();
    QuickView.open(b.getAttribute('data-quick-view'));
  });

  /* ------------------------------------------------- add to cart / buy -- */
  function formScope(el) { return el.closest('[data-product-form]') || document; }

  function collect(el) {
    var scope = formScope(el);
    var variantEl = scope.querySelector('input[data-variant-id]');
    var id = variantEl ? variantEl.value : '';
    var qtyEl = scope.querySelector('[data-qty] input');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    return { id: id, quantity: qty, scope: scope };
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-add-to-cart]');
    var buy = e.target.closest('[data-buy-now]');
    if (!atc && !buy) return;
    e.preventDefault();
    var btn = atc || buy;
    if (btn.disabled) return;

    var data = collect(btn);
    if (!data.id) {
      toast(CFG.strings.selectSize, false);
      return;
    }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = buy ? 'Redirecting…' : 'Adding…';

    Cart.add({ id: Number(data.id) || data.id, quantity: data.quantity })
      .then(function () {
        if (buy) {
          window.location.href = CFG.routes.checkout;
          return;
        }
        btn.disabled = false;
        btn.textContent = label;
        Modal.hide('quick-view');
        toast(CFG.strings.added);
        if (CFG.cartType === 'drawer') Drawer.show('cart-drawer');
        else window.location.href = CFG.routes.cart;
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        toast((err && err.message) || 'Something went wrong', false);
      });
  });

  /* ------------------------------------------------------- accordions -- */
  function initAccordions(scope) {
    $$('.acc__btn', scope || document).forEach(function (btn) {
      if (btn.__wired) return;
      btn.__wired = true;
      on(btn, 'click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---------------------------------------------------------- newsletter */
  function initNewsletter() {
    $$('[data-newsletter]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (form.getAttribute('data-newsletter') === 'demo') {
          e.preventDefault();
          var ok = form.parentElement.querySelector('.newsletter__ok');
          if (ok) ok.textContent = 'Thanks — you are on the list.';
          form.reset();
        }
      });
    });
  }

  /* -------------------------------------------------------------- boot -- */
  function boot() {
    initMobileNav();
    initNavDropdowns();
    initSearch();
    initHero();
    initReveal();
    initRails();
    initProductMarquee();
    initPicker();
    initQty();
    initAccordions();
    initNewsletter();
    Favorites.syncUI();
    Cart.get().catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', function (e) {
    initHero(e.target); initReveal(e.target); initRails(e.target);
    initProductMarquee(e.target);
    initPicker(e.target); initQty(e.target); initAccordions(e.target);
    initSearch(e.target); initMobileNav(); initNavDropdowns(); Favorites.syncUI();
  });

  CFG.refresh = boot;
  CFG.utils = { $: $, $$: $$, esc: esc, debounce: debounce, initReveal: initReveal, initPicker: initPicker, initQty: initQty, initRails: initRails, initProductMarquee: initProductMarquee };
})();
